import LoadingButton from '@mui/lab/LoadingButton';
import {
    Alert,
    DialogContent,
    Grid,
    Stack,
    TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import server from '../../../global/server';
import useHandleErrors from '../../../hooks/useHandleErrors';

export default ({ data, mutate }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    const {
        values, errors, dirty, handleChange, handleBlur,
        handleSubmit, isSubmitting, setValues, resetForm,
    } = useFormik({
        initialValues: {
            name: '',
            email: '',
            username: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`/backoffice/users/${data.id}`, {
                    name: values.name,
                    email: values.email,
                    username: values.username,
                });
                enqueueSnackbar('Dados do usuário atualizados', { variant: 'success' });
                setSubmitting(false);
                mutate();
            } catch (error) {
                setSubmitting(false);
                setErrs(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const vals = {
                name: data.name || '',
                email: data.email || '',
                username: data.username || '',
            };
            setValues(vals, true);
            resetForm({ values: vals });
        }
    }, [data]);

    return (
        <form onSubmit={handleSubmit}>
            <DialogContent>
                <Stack direction="row" pb={2} justifyContent="space-between">
                    <Alert sx={{ fontSize: 11, width: '100%' }}>
                        Cadastrado desde {data?.createdAt ? new Date(data.createdAt).toLocaleString('pt-BR') : '-'}
                    </Alert>
                </Stack>

                <Grid container rowSpacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Nome"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(errors.name)}
                            helperText={errors.name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(errors.email)}
                            helperText={errors.email}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Username"
                            name="username"
                            value={values.username}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(errors.username)}
                            helperText={errors.username}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                        <LoadingButton
                            type="submit"
                            fullWidth
                            loading={isSubmitting}
                            variant="contained"
                            disabled={!dirty || isSubmitting}
                            sx={{
                                bgcolor: '#006a61',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '8px',
                                '&:hover': { bgcolor: '#005a52' },
                            }}
                        >
                            Salvar usuário
                        </LoadingButton>
                    </Grid>
                </Grid>
            </DialogContent>
        </form>
    );
};
